import React from 'react';
import { Button, ButtonGroup } from '@blueprintjs/core';
import _ from 'lodash';

export default class SolutionVisualizer extends React.Component {

    constructor(props) {
        super(props);
        this.state = { final: true, step: 1 };
    }

    getCodeLine(instr, styled) {
        function styleTargetReg(targetReg) {
            if (styled && (targetReg[0] === "T" || targetReg[0] === "U"))
                return <span className="registerrenaming-solution-code-target">{targetReg}</span>;
            else
                return targetReg;
        }
        function styleSourceReg(sourceReg) {
            if (styled && (sourceReg[0] === "T" || sourceReg[0] === "U"))
                return <span className="registerrenaming-solution-code-source">{sourceReg}</span>;
            else
                return sourceReg;
        }

        if (instr.type === "int" || instr.type === "float") {
            if (!instr.regA && !instr.regB)
                return <>{styleTargetReg(instr.targetReg)} ← {instr.imm}</>;
            else if (!instr.regB)
                return <>{styleTargetReg(instr.targetReg)} ← {styleSourceReg(instr.regA)} {instr.aluOp} {instr.imm}</>;
            else
                return <>{styleTargetReg(instr.targetReg)} ← {styleSourceReg(instr.regA)} {instr.aluOp} {styleSourceReg(instr.regB)}</>;
        }
        else if (instr.type === "mem" && instr.subType === "store") {
            if (!instr.regA)
                return <>MEM[{instr.imm}] ← {styleSourceReg(instr.regB)}</>;
            else
               return <>MEM[{styleSourceReg(instr.regA)} {instr.aluOp} {instr.imm}] ← {styleSourceReg(instr.regB)}</>;
        }
        else if (instr.type === "mem" && instr.subType === "load") {
            if (!instr.regA)
                return <>{styleTargetReg(instr.targetReg)} ← MEM[{instr.imm}]</>;
            else
               return <>{styleTargetReg(instr.targetReg)} ← MEM[{styleSourceReg(instr.regA)} {instr.aluOp} {instr.imm}]</>;
        }
        else if (instr.type === "jump" && instr.subType === "direct")
            return <>JUMP {instr.imm}</>;
        else if (instr.type === "jump" && instr.subType === "indirect")
            return <>JUMP {styleSourceReg(instr.regB)}</>;
        else if (instr.type === "jump" && instr.subType === "conditional/direct")
            return <>JUMP {instr.imm} IF {styleSourceReg(instr.regA)} ${instr.aluOp} 0</>;
        else if (instr.type === "jump" && instr.subType === "conditional/indirect")
            return <>JUMP {styleSourceReg(instr.regB)} IF {styleSourceReg(instr.regA)} ${instr.aluOp} 0</>;
        return <>Unexpected instruction {instr.type}</>;
    }

    getCodePanel(title, instrList, upToLine) {
        return <div className="registerrenaming-solution-code-panel">
            <div className="registerrenaming-solution-code-title">{title}</div>
            {instrList.map((instr, ix) => <div key={ix} className="registerrenaming-solution-code-line" style={{ visibility: upToLine <= ix ? "hidden" : "visible" }}>
                {this.getCodeLine(instr, upToLine > instrList.length || upToLine === ix+1)}
            </div>)}
        </div>;
    }

    styleRATItem(step, reg, styled) {
        const oriReg = reg < 8 ? "R"+reg : "D"+(reg-8); 
        const text = (reg < 8 ? "U" : "T") + this.props.rat[step][reg];
        if (styled && step > 0 && oriReg === this.props.origInstrList[step-1].targetReg)
            return <span className="registerrenaming-rat-item-newtarget">{text}</span>;
        else if (styled && step > 0 && (oriReg === this.props.origInstrList[step-1].regA || oriReg === this.props.origInstrList[step-1].regB))
            return <span className="registerrenaming-rat-item-renamed">{text}</span>;
        else 
            return <span className="registerrenaming-rat-item-other">{text}</span>;
    }

    getRATPanel(upToLine) {
        return <div className="registerrenaming-solution-code-panel">
            <div className="registerrenaming-solution-code-title">A regiszterleképző tábla:</div>
            <table>
                <thead>
                    <tr><th>Logikai</th><th colSpan={upToLine+1}>Fizikai regiszter</th></tr>
                    <tr><th>regiszter</th><th>kezdő</th>{_.range(upToLine).map(ix => 
                        <th key={ix}>{ix+1}.{ix === upToLine-1 && upToLine === this.props.origInstrList.length ? " (végső)" : ""}</th>)}</tr>
                </thead>
                <tbody>
                    {_.range(12).map(ix => 
                        <tr key={ix}>
                            <td>{ix<8 ? "R"+ix : "D"+(ix-8)}</td>
                            {_.range(upToLine+1).map(step => 
                                <td key={step}>{this.styleRATItem(step, ix, this.state.final || step === upToLine)}</td>)}
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    static getDerivedStateFromProps(props, state) {
        if (props && props.origInstrList && state.step > props.origInstrList.length)
            return { step: props.origInstrList.length };
        return null;
    }

    render() {
        return <>
            <div className="registerrenaming-solution-container">
                <div className="registerrenaming-solution-controls">
                    <ButtonGroup>
                        <Button 
                            text="Végeredmény"
                            active={this.state.final}
                            onClick={() => this.setState({final: true})}
                        />
                        <Button 
                            text="Lépésenként"
                            active={!this.state.final}
                            onClick={() => this.setState({final: false})}
                        />
                    </ButtonGroup>
                    <div className="registerrenaming-solution-steps" style={{ visibility: this.state.final ? "hidden" : "visible"}}>
                        <ButtonGroup>
                            <Button 
                                icon="caret-left"
                                onClick={() => this.setState(state => ({step: Math.max(1, state.step-1)}))}
                            />
                            <Button 
                                icon="caret-right"
                                onClick={() => this.setState((state,props) => ({step: Math.min(props.origInstrList.length, state.step+1)}))}
                            />
                        </ButtonGroup>                    
                        <div>{this.state.step}. lépés utáni állapot</div>
                    </div>                    
                </div>

                <div className="registerrenaming-solution-main">
                    {this.getCodePanel("Eredeti utasítássorozat:", this.props.origInstrList, this.state.final ? this.props.origInstrList.length+1 : this.state.step)}
                    {this.getCodePanel("Átnevezés után:", this.props.renamedInstrList, this.state.final ? this.props.origInstrList.length+1 : this.state.step)}
                    {this.getRATPanel(this.state.final ? this.props.origInstrList.length : this.state.step)}
                </div>            
            </div>
        </>;
    }

}
